import getSMFurtherActionRules from './smFurtherActionRules';
import StateMachine from '../../services/stateMachine';

/**
 * Runs state machine, which returns an object with btnText, paragraphText and destination link.
 * @param model - tab data
 * @param config - configurations
 * @param stateCode
 */
export default (model, config, stateCode) => {
    const ROOT_STATE = 's_tabIsInsideOEEnrollmentWindow';
    let smFurtherActionsRes = {};
    const smFurtherActionRules = getSMFurtherActionRules(stateCode, config.isStateFullStack);
    const onFinishCb = res => smFurtherActionsRes = res;

    let stateMachineFurtherActions = new StateMachine(smFurtherActionRules,
        ROOT_STATE,
        onFinishCb);

    stateMachineFurtherActions.run(model, config);

    return smFurtherActionsRes;
};